(() => {
  const root = document.querySelector('[data-mpb]');
  if (!root || root.dataset.mpbReady === 'true') return;
  root.dataset.mpbReady = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('is-ready');

  const revealItems = Array.from(root.querySelectorAll('[data-mpb-reveal]'));
  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach((item) => revealObserver.observe(item));
  }

  const slider = root.querySelector('[data-mpb-slider]');
  if (slider) {
    const slides = Array.from(slider.querySelectorAll('.mpb__hero-slide'));
    const bars = Array.from(slider.querySelectorAll('.mpb__hero-progress span'));
    let active = 0;
    let timer = null;
    let pending = false;
    let hovering = false;
    let focused = false;

    const commit = (index) => {
      active = index % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === active));
      bars.forEach((bar, barIndex) => {
        bar.classList.remove('is-active');
        if (barIndex === active) {
          void bar.offsetWidth;
          bar.classList.add('is-active');
        }
      });
    };

    const show = async (index) => {
      if (pending || document.hidden || hovering || focused || !root.isConnected) return;
      pending = true;
      const image = slides[index % slides.length]?.querySelector('img');
      try {
        if (image) {
          image.loading = 'eager';
          if (!image.complete) await new Promise((resolve, reject) => {
            const cleanup = () => { image.removeEventListener('load', loaded); image.removeEventListener('error', failed); };
            const loaded = () => { cleanup(); resolve(); };
            const failed = () => { cleanup(); reject(new Error('Image unavailable')); };
            image.addEventListener('load', loaded, { once: true });
            image.addEventListener('error', failed, { once: true });
          });
          if (!image.naturalWidth) return;
          if (image.decode) await image.decode();
        }
        if (document.hidden || hovering || focused || !root.isConnected) return;
        commit(index);
      } catch (error) {
        return;
      } finally {
        pending = false;
      }
    };

    const start = () => {
      window.clearInterval(timer);
      if (reducedMotion || slides.length < 2 || document.hidden || hovering || focused || !root.isConnected) return;
      timer = window.setInterval(() => {
        if (!root.isConnected) { window.clearInterval(timer); return; }
        show(active + 1);
      }, 4800);
    };

    commit(0);
    start();
    slider.addEventListener('mouseenter', () => { hovering = true; start(); });
    slider.addEventListener('mouseleave', () => { hovering = false; start(); });
    slider.addEventListener('focusin', () => { focused = true; start(); });
    slider.addEventListener('focusout', event => { focused = slider.contains(event.relatedTarget); start(); });
    document.addEventListener('visibilitychange', start);
  }

  const nav = root.querySelector('[data-mpb-nav]');
  const sections = Array.from(root.querySelectorAll('[data-mpb-section][id]'));
  if (nav && sections.length && 'IntersectionObserver' in window) {
    const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
    const setActive = (id) => {
      links.forEach((link) => {
        const activeLink = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', activeLink);
        if (activeLink) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    const sectionObserver = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) setActive(visible.target.id);
    }, { rootMargin: '-22% 0px -62% 0px', threshold: [0.01, 0.15, 0.4] });
    sections.forEach((section) => sectionObserver.observe(section));
  }

  root.querySelectorAll('.mpb__faq-groups section').forEach((group) => {
    group.addEventListener('toggle', (event) => {
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
      group.querySelectorAll('details[open]').forEach((details) => {
        if (details !== opened) details.open = false;
      });
    }, true);
  });
  root.querySelectorAll('[data-mpb-review-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const card = button.closest('.mpb__review-card');
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      button.textContent = expanded ? 'More' : 'Less';
      card?.classList.toggle('is-expanded', !expanded);
    });
  });

})();

